module.exports = __webpack_public_path__ + "img/mturk_special_note_to_workers.552393c0.png";